<template>
	<div v-parallax-fit="parallax" class="hand">
		<img src="/themes/rise-theme/dist/images/estate/character-view/holly/15_Purchase_02.png" alt="">
	</div>
</template>

<script>
	export default {
		data() {
			return {
				parallax: [
					{
						start: 6500,
						end: 9000,
						fromStyle: { transform: 'translateX(0%) translateY(250%)' },
           				toStyle: { transform: 'translateX(-60%) translateY(-10%)' },
						easing: 'linear'
					},
					{
						start: 9000,
						end: 12000,
						fromStyle: { transform: 'translateX(-60%) translateY(-10%)' },
           				toStyle: { transform: 'translateX(-60%) translateY(250%)' },
						easing: 'linear'
					}
				]
			}
		}
	}
</script>

<style lang="scss" scoped>
	.hand {
		position: fixed;
		top: 50%;
		left: 100%;
		z-index: 2;
		max-width: 2000px;
		width: 100%;
		transition: all 0.1s linear;
	}
</style>
